module.exports = __webpack_public_path__ + "static/img/cert-03.59e3722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert/cert-03.png
// module id = HT7n
// module chunks = 1